var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset186(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.79 118.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#e5c15c;}.cls-1{opacity:0.15;}.cls-3{fill:#e5c15c;}.cls-4{fill:#fff;}.cls-5{fill:#3e6177;}.cls-6{fill:#d5dfeb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 186") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -14.21,
    y: 34.29,
    width: 147,
    height: 50,
    rx: 25,
    ry: 25,
    transform: "translate(-24.56 59.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.79,
    y: 12.29,
    width: 20,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 74.79,
    y: 23.29,
    width: 20,
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.79,
    y: 46.29,
    width: 20,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.29,53.29a6.5,6.5,0,1,1,6.5-6.5A6.51,6.51,0,0,1,105.29,53.29Zm0-10a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,105.29,43.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.29,35.29a6.5,6.5,0,1,1,6.5-6.5A6.51,6.51,0,0,1,45.29,35.29Zm0-10a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,45.29,25.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 56.04,
    cy: 101.04,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 26.04,
    cy: 5.04,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 115.04,
    cy: 96.04,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 6.04,
    cy: 30.04,
    r: 2.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.79,93.29h-23v-83h23Zm-20-3h17v-77h-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.79,93.79h-23v-49h23Zm-20-3h17v-43h-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.79,94.29h-23v-71h23Zm-20-3h17v-65h-17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.46,
    y: 16.29,
    width: 2,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.46,
    y: 32.29,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.46,
    y: 40.29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 93.32,
    y: 87.88,
    width: 2,
    height: 12.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 93.32,
    y: 102.38,
    width: 2,
    height: 5.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 93.32,
    y: 109.63,
    width: 2,
    height: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 92.62,
    cy: 85.95,
    r: 26.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 93.53,
    cy: 85.95,
    r: 21.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.62,108.68a22.73,22.73,0,1,1,22.73-22.73A22.76,22.76,0,0,1,92.62,108.68Zm0-42.47a19.73,19.73,0,1,0,19.73,19.73A19.76,19.76,0,0,0,92.62,66.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.7,95.43a1.92,1.92,0,0,1-1.1-.35l-7.67-5.37a1.5,1.5,0,0,1,1.72-2.46L90.47,92l11.13-14.84A1.5,1.5,0,1,1,104,79L92.24,94.65A1.92,1.92,0,0,1,90.7,95.43Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset186);
export default __webpack_public_path__ + "static/media/Asset186.6734bca2feb299fe1085523ec939ec85.svg";
export { ForwardRef as ReactComponent };